/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Home({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M2.03 7.122a1 1 0 0 1 .346-.756l4.97-4.3a1 1 0 0 1 1.308 0l4.97 4.3a1 1 0 0 1 .346.756V13.5a1 1 0 0 1-1 1h-2.134a1 1 0 0 1-1-1v-3.016a1 1 0 0 0-1-1H7.164a1 1 0 0 0-1 1V13.5a1 1 0 0 1-1 1H3.03a1 1 0 0 1-1-1z" /></svg>;
}
;